import { createSelector } from 'reselect';

import {
  selectApp,
  selectT,
  selectFlags,
  selectLocation,
  selectDealSearch,
  selectLocationSearch,
} from 'app/common/selectors/common';
import {
  selectSearchError,
  selectLocationKeyword,
} from 'app/common/selectors/locationSuggestions';
import { selectDealKeyword } from 'app/common/selectors/dealSuggestions';

export const selectSearch = state => state.search;

export const searchSelector = createSelector(
  selectApp,
  selectT,
  selectFlags,
  selectLocation,
  selectSearch,
  selectSearchError,
  selectLocationKeyword,
  selectDealKeyword,
  selectDealSearch,
  selectLocationSearch,
  (
    app,
    t,
    flags,
    location,
    search,
    locationErrorStatus,
    locationKeyword,
    dealKeyword,
    dealSearch,
    locationSearch
  ) => ({
    app,
    t,
    flags,
    location,
    search,
    locationErrorStatus,
    locationKeyword,
    dealKeyword,
    dealSearch,
    locationSearch,
  })
);
